// extracted by mini-css-extract-plugin
module.exports = {"unauthorizedPage":"unauthorized_unauthorizedPage__x2IPy","logoutButton":"unauthorized_logoutButton__2VpZq"};